import script from "./VirtualSettingRegistPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualSettingRegistPage.vue?vue&type=script&setup=true&lang=js"

import "./VirtualSettingRegistPage.vue?vue&type=style&index=0&id=31dc1011&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31dc1011"]])

export default __exports__